var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19,
    stroke: "#C0C2C6",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_68_42387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.8333 12.5H14.1667C13.2417 12.5 12.5 13.25 12.5 14.1667V25.8333C12.5 26.75 13.2417 27.5 14.1667 27.5H25.8333C26.75 27.5 27.5 26.75 27.5 25.8333V14.1667C27.5 13.25 26.7583 12.5 25.8333 12.5ZM25.8333 25.8333H14.1667V15.8333H25.8333V25.8333ZM24.1667 20H15.8333V18.3333H24.1667V20ZM20.8333 23.3333H15.8333V21.6667H20.8333V23.3333Z",
    fill: "#C0C2C6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_68_42387"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductDisabled);
export default __webpack_public_path__ + "static/media/product-disabled.d5641ab5f7ce6b3fcccc57c8a5bc6882.svg";
export { ForwardRef as ReactComponent };